import { HiDocumentText } from "react-icons/hi";

import { Deal } from "@Types/deal";
import { Priority, Status } from "@Types/tickets";
import useCurrentUser from "@Hooks/useCurrentUser";
import { useCreateTicket } from "@Hooks/useTickets";

import {
  stateMachine,
  initialTicketState,
  initialLoanTicketState,
} from "../SupportMachine/TicketStateMachine";
import styles from "./TicketsChat.module.scss";
import { CommonProps } from "../SupportMachine/types";
import { handleInteraction } from "../SupportMachine/stateMachineInteractions";

const RecursiveRender = ({ state, setState, text, setText }: CommonProps) => {
  const user = useCurrentUser();
  const { createTicket, loading } = useCreateTicket();

  const handleSubmit = () => {
    if (!loading) {
      const dealId = state.ticketData.deal?._id;
      const issueType = dealId ? "Loan" : "Title";

      createTicket({
        files: state.ticketData.files,
        data: {
          dealId: dealId,
          replyTo: [
            user?.data.info.email as string,
            ...(state.ticketData.participant
              ? [state.ticketData.participant]
              : []),
          ],
          info: {
            subject: `${
              dealId ? `${issueType} Issue - ${dealId}` : "General Issue"
            }`,
            description: state.ticketData.description ?? "",
            status: Status.Open,
            priority: state.ticketData.priority ?? Priority.Low,
          },
        },
      });
      handleReset();
    }
  };
  const handleReset = () =>
    setState(
      state.type === "dashboard"
        ? initialTicketState
        : initialLoanTicketState(state.ticketData.deal as Deal)
    );

  const renderOptions = () => {
    return state.options.map((option, index) => {
      const stateComponent = stateMachine[state.name].options[index].component;

      const props = {
        prevState: state,
        optionIndex: index,
        currentState: state.name,
        setState,
      };

      const onClick = () =>
        option.type === "submit"
          ? handleSubmit()
          : option.onClick
          ? option.onClick(props)
          : handleInteraction(props);
      return stateComponent ? (
        <div key={index} className={styles.stateComponent}>
          {stateComponent({
            index,
            state,
            setState,
            text,
            setText,
          })}
        </div>
      ) : (
        <div key={index} onClick={onClick} className={styles.response}>
          <div>{option.title}</div>
        </div>
      );
    });
  };

  const renderSelectedOption = () => {
    const selectedOption = state.dataName
      ? state.ticketData[state.dataName]
      : state?.selectedOption?.title;

    return (
      <div className={styles.selectedOptionContainer}>
        {selectedOption && (
          <div className={styles.selectedOption}>{selectedOption} </div>
        )}
        {state.dataName === "description" &&
          state.ticketData.files.length > 0 &&
          state.ticketData.files.map((file) => (
            <div key={file.name} className={styles.previewFile}>
              <HiDocumentText color="white" size={40} /> {file.name}
            </div>
          ))}
        {state.selectedOption?.selectedOptionComponent &&
          state.selectedOption.selectedOptionComponent({
            deal: state?.ticketData.deal ?? undefined,
          })}
      </div>
    );
  };

  return (
    <>
      {state.previousState && (
        <RecursiveRender
          state={state.previousState}
          setState={setState}
          text={text}
          setText={setText}
        />
      )}

      <div className={styles.messagesContainer}>
        {state.stateComponent &&
          state.ticketData.deal &&
          state.stateComponent({ deal: state.ticketData.deal })}

        {state.messages.map((message, index) => (
          <div key={index} className={styles.messageContainer}>
            <div className={styles.message}>{message}</div>
          </div>
        ))}
        {state.selectedOption ? (
          renderSelectedOption()
        ) : (
          <div className={styles.responseContainer}>{renderOptions()}</div>
        )}
      </div>
    </>
  );
};

export default RecursiveRender;
